define('views/modules/calendar/nutrition/nutrition-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // src
    'services/viewport',
    'services/layout',
    'services/user',
    // models & collections
    'collections/calendar/nutrition/entries',
    // Views
    'views/modules/calendar/nutrition/entry/nutrition-day-log',
    'views/modules/calendar/nutrition/nutrient/nutrient-report',
    'views/modules/calendar/nutrition/food/food-panel',
    'views/modules/calendar/calendar-item-panel-content',
    'views/modules/calendar/favorite/favorite-modal',
    'views/modules/calendar/nutrition/water/water-counter',
    'views/modules/calendar/nutrition/calories/calorie-goal',
    'views/modules/member/member/edit/member-edit-panel',
    'views/modules/calendar/animated-session/session/form/session-form',
    // Templates Blocks
    'text!templates/modules/calendar/nutrition/nutrition-edit-content.html',
    'views/parts/form/choices',
    // events
    'services/events/nutrition-events',
    'services/events/user-events',
    // services
    'services/i18n'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // src
    Viewport,
    LayoutState,
    User,
    // models & collections
    CFoodEntries,
    // Views
    VNutritionDayLog,
    VNutrientReport,
    VFoodPanel,
    VCalendarItemPanelContent,
    VFavoriteModal,
    VWaterCounter,
    VCalorieGoal,
    VMemberEditPanel,
    VSessionForm,
    // Template
    TNutritionEditContent,
    VChoices,
    NutritionEvents,
    UserEvents,
    // services
    i18n
) {

    var VNutritionEditContent = VCalendarItemPanelContent.extend({
        fields: VCalendarItemPanelContent.prototype.fields.concat(['entries', 'water', 'photos', 'notes', 'displayName']),
        contentTemplate: TNutritionEditContent,
        events: {
            "click .food-toggle": "toggleAll"
        },
        regions: _.extend(VCalendarItemPanelContent.prototype.regions, {
            detailsForm: "#nutrition-details-form",
            log: ".nutrition-day-log",
            report: ".nutrition-daily-report",
            water: ".nutrition-water-counter",
            calorie_goal: ".nutrition-calories",
            toggleAll: '.food-toggle',
        }),

        initialize: function(opt) {
            VNutritionEditContent.__super__.initialize.call(this, opt);

            var model = this.model,
                collection = this.collection = new CFoodEntries(),
                view = _.extend(this.view, {
                    detailsForm: new VSessionForm({ 
                        model: model,
                        attributes: {
                            textBox: 'displayName'
                        }
                    }),
                    log: new VNutritionDayLog({
                        model: model,
                        collection: collection
                    }),
                    report: new VNutrientReport({ collection: collection }),
                    water: new VWaterCounter({ model: model }),
                    calorie_goal: new VCalorieGoal({ model: model, profile: this.profile, collection: this.collection, isSupervisor: this.options.group.isSupervisor() }),
                    toggleAll: new VChoices({ label: "calendar:toggleall", styleButton: true }),
                });

            var moreActions = new Backbone.Collection([
                { icon: 'fa fa-plus', caption: 'calendar:Add an entry to this log', callback: this.onAddFoodAction, context: this },
            ]);

            if (this.role === 'supervisor') {
                moreActions.add({ icon: 'sl-icon-star', caption: i18n.t('calendar:add-nutrilog-to-favorite'), callback: this.onAddToFavoriteAction, context: this });
            }

            moreActions.add([
                { icon: 'sl-icon-check', caption: i18n.t('calendar:Mark all as consumed'), context: this, callback: this.onMarkAllAsConsumed },
                { icon: 'sl-icon-close', caption: i18n.t('calendar:Mark all as not consumed'), context: this, callback: this.onMarkAllAsNotConsumed },
            ])

            view.menu.addMoreActions(moreActions);

            this.listenTo(collection, { 'update change entry:add': this.onEntryListChange })
                .listenTo(model, {
                    'model:reset': this.onModelReset,
                    'favorite:create': this.onFavoriteCreate,
                    'favorite:applied': this.onFavoriteApplied,
                })
                .listenTo(view.log, 'add:food', this.onAddFoodAction);
            this.listenTo(collection, { 'update change entry:add': this.swapLabel });

            this.listenTo(NutritionEvents, { 'food:calorieGoalTarget': this.onDefineCalorieGoalTarget });
            this.listenTo(UserEvents, { 'member:sendMemberFullList': this.toggleMemberEditPanel });
            this.listenTo(UserEvents, { 'member:closingEditSettingPanel': this.onDisplayFoodAction });

            this.listenTo(model, { 'change': this.onModelChange });

            this.isAllEaten = false;

            this.resetCollection();
        },

        render: function() {
            VNutritionEditContent.__super__.render.apply(this, arguments);

            this.getDayCalories();

            var view = this.view,
                zone = this.zone;
            this.assign(view.log, zone.$log)
                .assign(view.report, zone.$report)
                .assign(view.water, zone.$water)
                .assign(view.calorie_goal, zone.$calorie_goal)
                .assign(view.toggleAll, zone.$toggleAll)
                .assign(view.detailsForm, zone.$detailsForm);

            if (!Viewport.isMobile()) {
                this.toggleFoodPanel(true);
            }

            if (User.getCurrentlySelectedUser().get('disable_calorie_goal')) {
              this.$('.calorie-goal-box').hide();
            }

            this.view.detailsForm.toggleNote(this.model.get("notes"));

            this.view.toggleAll.setValue(this.isListAllChecked());
            this.swapLabel();
            return this;
        },

        toggleFoodPanel: function(val, model) {
            var view = this.view,
                foodView = view.food || (view.food = new VFoodPanel({ suggestion: this.role === 'supervisor' }));
            if (model) foodView.setModel(model);

            this.trigger('drawer:view', foodView, val);
            return this;
        },

        onDefineCalorieGoalTarget: function(clientModel) {
            this.clientModel = clientModel;
            //Here, we talk to the member-content view to tell them to send us his member list
            //NB: Only if in supervisor mode
            if (Backbone.history.getFragment().indexOf('supervisor') > -1) {
                UserEvents.getMemberFullList();
            } else {
                //if in client mode, we don't need the group list. The group drop down will be hidden in client edit settings
                this.toggleMemberEditPanel(null, true);
            }
        },

        toggleMemberEditPanel: function(memberFullList) {
          var SelectedUserGroup = null;
          if (memberFullList) {
              var userGrpId = User.getCurrentlySelectedUser().get("group");
              //Oblige de faire ces boucles d'idiot car un findWhere rechercherait juste dans les groupes racines et ici ont a une arborescence avec des subgroups
              for (var i = 0; i < memberFullList.groups.models.length; i++) {
                  var grpRoot = memberFullList.groups.models[i];
                  if (grpRoot.get("_id") === userGrpId) {
                      SelectedUserGroup = grpRoot;
                      break;
                  }
                  for (var j = 0; j < grpRoot.get("subgroups").models.length; j++) {
                      var grpSecondLevel = grpRoot.get("subgroups").models[j];
                      if (grpSecondLevel.get("_id") === userGrpId) {
                          SelectedUserGroup = grpSecondLevel;
                          break;
                      }
                  }
                  if (SelectedUserGroup !== null) {
                      break;
                  }
              }
          }

          var view = this.view,
              memberEditView = view.memberEditView || (view.memberEditView = new VMemberEditPanel({
                                                                                        model: this.clientModel,
                                                                                        memberList: memberFullList,
                                                                                        selectedGroup: SelectedUserGroup
                                                                                    }));
          this.trigger('drawer:view', memberEditView, true);
          return this;
        },

        getDayCalories: function() {
          this.$el.find('#calories').html(parseInt(this.collection.getCalories()));
          this.$el.find('#totalCalories').html(parseInt(this.collection.getTotalCalories()));
        },

        hasCollectionChanged: function() {
            return !this.collection.equals(this.collectionCopy);
        },

        resetCollection: function() {
            var collection = this.collection;
            collection.reset(this.model.getEntries());
            this.collectionCopy = this.collection.toJSON({ blacklist: true });
        },

        isListAllChecked: function() {
            var collection = this.collection;

            var isAllEaten = true;

            collection.forEach(function(k, v) {
                if (!k.isEaten()) {
                    isAllEaten = false;
                }
            });

            return isAllEaten;
        },

        isDirty: function() {
            return VNutritionEditContent.__super__.isDirty.call(this) || this.hasCollectionChanged();
        },

        toggleEntriesEaten: function() {
            var isEaten = !this.model.isDone();
            this.collection.invoke('set', { isEaten: isEaten });
        },

        setEntries: function() {
            if (this.hasCollectionChanged()) {
                this.model.setEntries(this.collection.toJSON({ blacklist: true }));
            }
        },

        /////////////
        // actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },
        onAddFoodAction: function() {
            this.toggleFoodPanel(true);
        },

        onDisplayFoodAction: function() {
          if (!Viewport.isMobile()) {
              this.toggleFoodPanel(true);
          }
        },

        onAddToFavoriteAction: function() {
            var view = this.view.favorite;

            if (!view) {
                view = this.view.favorite = new VFavoriteModal({
                    type: 'nutrilog',
                    item: this.model
                });
                this.listenTo(view, 'form:success', this.onFavoriteSuccess);
            }

            view.resetModel().render();
        },
        ////////////
        // events //
        ////////////

        onDone: function() {
            this.toggleEntriesEaten();
            VNutritionEditContent.__super__.onDone.apply(this, arguments);
        },

        toggleAll: function() {
            NutritionEvents.toggleAll(!this.isListAllChecked());
            this.isAllEaten = !this.isAllEaten;

            this.swapLabel();
        },

        swapLabel: function() {
            if (this.isListAllChecked()) {
                this.view.toggleAll.collection.models[0].set('label', i18n.t('calendar:untoggleall'));
            } else {
                this.view.toggleAll.collection.models[0].set('label', i18n.t('calendar:toggleall'));
            }

            this.assign(this.view.toggleAll, this.zone.$toggleAll);
            this.view.toggleAll.render();
        },

        onNutritionEdit: function(model) {
            this.toggleFoodPanel(true, model);
        },

        onModelReset: function(model, options) {
            this.resetCollection();
        },

        onEntryListChange: function() {
            this.getDayCalories();
            this.onModelChange();
            this.view.toggleAll.setValue(this.isListAllChecked());
        },

        onValidate: function() {
            var result = this.collection.isValid();
            if (!result) {
                this.collection.each(function(model) {
                    if (model.validationError) U.warn(model.validationError);
                });
            }
            return result;
        },

        onSubmit: function() {
            var waterCounterValue = this.view.water.getValue();
            this.model.set('water', waterCounterValue);
            this.setEntries();
        },

        onFavoriteApplied: function() {
            this.collection.reset(this.model.getEntries());
        },

        onFavoriteCreate: function() {
            this.model.trigger('favorite:set:collection', 'entries', this.collection.toJSON({ blacklist: true }));
        },

        onFavoriteSuccess: function(model) {
            this.trigger('favorite:success', model);
        },

        onMarkAllAsConsumed: function() {
            NutritionEvents.markAllAsConsumed();
        },

        onMarkAllAsNotConsumed: function() {
            NutritionEvents.markAllAsNotConsumed();
        },
    });

    return VNutritionEditContent;

});

